var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{staticStyle:{"margin-bottom":"16px"},attrs:{"gutter":20}},[_c('el-col',{staticClass:"title-txt",attrs:{"span":7},domProps:{"innerHTML":_vm._s(_vm.featureText)}}),_vm._v(" "),_c('el-col',{staticClass:"desc-style omit1",attrs:{"span":17}},[_vm._v(_vm._s(_vm.processFeatureType(this.feature)))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07ab9223","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/search/SnapshotFeature.vue
// module id = null
// module chunks = 